import { useState } from "react";
import { isBotAgent } from "./data/sport-utils";

export function useScrollableData(data=[], startItemsSize=5, moreItemsSize=5, enabled = (!isBotAgent()), container='window'){

    const [scrollableData,setScrollableData] = useState({
        data,
        visibleItems: [],
        enabled,
        container, // 'window' or 'parent'
        loading: false,
        hasMoreItems: true,
        scrollSettings : {
            dim: moreItemsSize
        },
        scrolledItems: {
            prev: 0,
            next:startItemsSize
        },
        /*getNextData: function () {
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    loading:true,
                }
            });
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    visibleItems:prevState.data.slice(prevState.scrolledItems.prev -1, prevState.scrolledItems.next),
                    scrolledItems: { prev:prevState.scrolledItems.prev +1, next: prevState.scrolledItems.next + 1 },
                    loading: false,
                    hasMoreItems:prevState.visibleItems.length !== prevState.data.length
                }
            });
        },
        getPrevData: function () {
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    loading:true,
                }
            });
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    visibleItems:prevState.data.slice(prevState.scrolledItems.prev-2, prevState.scrolledItems.next-1),
                    scrolledItems: { prev:prevState.scrolledItems.prev -1, next: prevState.scrolledItems.next -1 },
                    loading: false,
                    hasMoreItems:prevState.visibleItems.length !== prevState.data.length
                }
            });
        },
        */
        getMoreData: function () {
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    loading:true,
                }
            });
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    visibleItems:prevState.visibleItems.concat(prevState.data.slice(prevState.scrolledItems.prev + prevState.scrollSettings.dim, prevState.scrolledItems.next + prevState.scrollSettings.dim)),
                    scrolledItems: { prev:prevState.scrolledItems.prev + prevState.scrollSettings.dim, next: prevState.scrolledItems.next + prevState.scrollSettings.dim },
                    loading: false,
                    hasMoreItems:prevState.visibleItems.length !== prevState.data.length
                }
            });
        },
        setData: function(data){
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    data,
                    hasMoreItems: data.length > 0
                }
            });
        },
        resetData: function(data, startItemsSize){
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    data,
                    visibleItems: data.slice(0, startItemsSize),
                    scrolledItems: {
                        prev: startItemsSize-1,
                        next:startItemsSize
                    },
                    hasMoreItems: data.length > 0
                }
            });
        },
        resetItems: function(items){
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    visibleItems: items.slice(0,prevState.scrolledItems.next),
                    hasMoreItems: prevState.scrolledItems.next < items.length
                }
            });
        },
        resetScrolledItems: function(){
            setScrollableData(function(prevState) {
                return {
                    ...prevState,
                    visibleItems: prevState.data.slice(0,prevState.scrolledItems.next)
                }
            });
        }
    })

    return [scrollableData,setScrollableData];

}